import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import {
  deleteOneInvoice,
  getInvoiceList,
} from "../../../redux/invoice/action";
import Check from "../../assets/images/checkk.svg";
import Cross from "../../assets/images/cross.svg";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import DeleteInvoices from "./DeleteInvoices";
import InvoiceFilters from "./InvoiceFilters";
import ZatcaModals from "./ZatcaModals";

const CreditNotesLists = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);
  const [zatcaMod, setZatcaMod] = useState(false);
  const [zatDetails, setZatDetails] = useState(null);
  const [isloading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    user_id: 1,
    start_date: "",
    end_date: "",
    status: "",
    invoice_type: 3,
    testing_account_filter: "hide",
  });
  const invoiceList = useSelector((state) => state?.reusableSlice?.invoiceList);

  useEffect(() => {
    dispatch(getInvoiceList(params))
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => setIsLoading(false));
  }, [dispatch, params]);

  const addComponent = () => {
    navigate("/addinvoices");
  };

  const updateComponent = (id) => {
    navigate(`/viewnotes/${id}/1`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneInvoice(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const handleZatcaDetails = (zat) => {
    setZatDetails(zat);
    setZatcaMod(true);
  };

  return (
    <div className="py-3">
      {isloading ? (
        <FullScreenLoader />
      ) : (
        <div>
          <Modal isOpen={modals} toggle={() => setModals(!modals)}>
            <InvoiceFilters
              modal={modals}
              setModal={setModals}
              params={params}
              setParams={setParams}
              invoiceType="3"
            />
          </Modal>
          <CardHeader
            params={params}
            headerTitle="Credit Notes"
            setParams={setParams}
            addmodel={addComponent}
            search={search}
            setOpenFilter={setOpenFilter}
            modals={modals}
            setModals={setModals}
          />

          <CardBody className="table-sec px-3">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Company</th>
                  <th scope="col">Invoice Number</th>
                  <th scope="col">Environment</th>
                  <th scope="col">Email Id</th>
                  <th scope="col">Mobile Number</th>
                  <th scope="col">Parent Invoice</th>
                  <th scope="col" >Parent Invoice type</th>
                  <th scope="col">Date</th>
                  <th scope="col">Invoice Total(SAR)</th>
                  <th scope="col">ZATCA Integration</th>
                  <th scope="col">Reported</th>
                  <th scope="col">Signed</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoiceList?.invoices?.length > 0 ? (
                  invoiceList?.invoices?.map((item, index) => (
                    <tr key={index}>
                      <td> {index + 1 + (params?.page - 1) * 10}</td>
                      <td>{item?.company_name} </td>
                      <td>{item?.invoice_number} </td>
                      <td>
                        <span className={`sf-env-badge ${item?.is_test ? "sandbox" : "live"}`}>
                          {item?.is_test ? "TEST" : "LIVE"}
                        </span>
                      </td>
                      <td>{item?.email_id} </td>
                      <td>
                        {item?.country_code} {item?.mobile_number}{" "}
                      </td>

                      <td>
                     {item?.parent_invoice_number}
                      </td>
                      <td>{item.client_type === 1 ? "VAT" : "Simplified"}</td>
                      <td>{item?.date_time || "--"}</td>
                      <td>{item?.total} </td>
                      <td>{item?.onboarding===1?" Phase 2":" Phase 1"}</td>
                      <td>
                        {" "}
                       {item?.onboarding===0?<h5>--</h5>: <img
                          src={item?.zatca_status == "REPORTED" ? Check : Cross}
                          alt=""
                        />}{" "}
                      </td>
                      <td>
                        {" "}
                       {item?.onboarding===0?<h5>--</h5>: <img
                          src={item?.signed_xml_url ? Check : Cross}
                          alt=""
                        />}{" "}
                      </td>
                      
                      <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          <button
                            className="border-button"
                            onClick={() => handleZatcaDetails(item)}
                          >
                            <span>ZATCA</span>
                          </button>
                          {/* <button
                            className="border-button"
                            onClick={() => updateComponent(item?.id)}
                          >
                            <span>View</span>
                          </button>
                          <button
                            className="background-button"
                            onClick={() => {
                              setModal(true);
                              setCurrentComponent(item);
                            }}
                          >
                            <span>Delete</span>
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No Notes Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={invoiceList?.pagination_meta}
          />
          <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
            <DeleteInvoices
              modalTitle={"Invoice"}
              itemType="invoice"
              setModal={setModal}
              currentComponent={currentComponent}
              deleteComponent={deleteComponent}
            ></DeleteInvoices>
          </Modal>
          <Modal size="lg" isOpen={zatcaMod} toggle={() => setZatcaMod(true)}>
            <ZatcaModals
              zatcaMod={zatcaMod}
              setZatcaMod={setZatcaMod}
              data={zatDetails}
            />
          </Modal>
        </div>
      )}
    </div>
  );
};
export default CreditNotesLists;
